import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { CartSchema, UpdateCartItemDTO } from '@app/models/products';
import Api from '@app/services/api';

interface IProps {
  catalog_uid: string;
  data: UpdateCartItemDTO;
}

export const usePostUpdateCartItem = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ data, catalog_uid }: IProps) => {
      const res = await Api.products.postUpdateCartItem(catalog_uid, data);
      return res;
    },
    onSuccess: async (response, { catalog_uid }) => {
      await client.setQueryData<CartSchema>(['getCart', catalog_uid], (oldData) => {
        const cartItem = response.cart_item;

        return oldData
          ? {
              ...oldData,
              items:
                oldData.items && cartItem
                  ? [
                      ...oldData.items.map((el) => {
                        if (el.uid === cartItem.uid) {
                          return cartItem;
                        } else return el;
                      }),

                      ...(oldData.items.every((el) => el.product.uid !== cartItem.product.uid) ? [cartItem] : []),
                    ]
                  : oldData.items,
              total: response.cart_total,
              items_total: response.cart_items_total,
            }
          : oldData;
      });

      return response;
    },
    onError: () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
  });
};
